import r from "./index433.js";
import { resolveComponent as s, createElementBlock as a, openBlock as c, createVNode as i, createTextVNode as m, toDisplayString as p } from "vue";
import l from "./index231.js";
const k = ["data-component"];
function d(o, e, f, u, _, $) {
  const t = s("cs-bookmark-icon");
  return c(), a("div", {
    "data-component": o.$options.name,
    class: "flex items-center gap-8 cursor-pointer",
    onClick: e[0] || (e[0] = (...n) => o.onClick && o.onClick(...n))
  }, [
    i(t, { hasDot: o.hasDot }, null, 8, ["hasDot"]),
    m(" Merkliste (" + p(o.amount) + ") ", 1)
  ], 8, k);
}
const B = /* @__PURE__ */ l(r, [["render", d]]);
export {
  B as default
};
